import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import StatePage from "./pages/StatePage";
import FileUploadPage from "./pages/FileUploadPage";
import DatatablePage from "./pages/DatatablePage";
import SidebarLayout from "./SidebarLayout";
import * as constants from "./services/util";
import "../src/App.css";
import Login from "./pages/Login";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./services/AuthContext";
import ProtectedRoute from "./services/ProtectedRoute";

import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";

Amplify.configure(awsExports);


function NotFoundPage() {
  return <div>Page Not Found</div>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SidebarLayout key={window.location.pathname}>
        <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={ <StatePage usState={constants.CONFLICT_RESOLUTION_PROGRAM} program={constants.CRP} />} />
            <Route path="/file-uploader" element={<ProtectedRoute> <FileUploadPage /> </ProtectedRoute>} />
            <Route path="/conflict-resolution-program" element={ <StatePage usState={constants.CONFLICT_RESOLUTION_PROGRAM} program={constants.CRP} />} />
            <Route path="/arizona" element={<StatePage usState={constants.ARIZONA} program={constants.CRP} />} />
            <Route path="/florida" element={<StatePage usState={constants.FLORIDA} program={constants.CRP} />} />
            <Route path="/georgia" element={<StatePage usState={constants.GEORGIA} program={constants.CRP} />} />
            <Route path="/michigan" element={<StatePage usState={constants.MICHIGAN} program={constants.CRP} />} />
            <Route path="/north-carolina" element={<StatePage usState={constants.NORTH_CAROLINA} program={constants.CRP} /> } />
            <Route path="/wisconsin" element={<StatePage usState={constants.WISCONSIN} program={constants.CRP} />} />
            <Route path="/democracy-program" element={<StatePage program={constants.DP} />} />
            <Route path="/data-table" element={<DatatablePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </SidebarLayout>
      </AuthProvider>{" "}
    </BrowserRouter>
  );
}

export default App;
